import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../../../components/CustomButton";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import Label from "./../../../components/Label/index";
import { t } from "i18next";

const buttonStyle = {
  height: 40,
  width: 100,
  borderRadius: 1,
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    maxWidth: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .close-icon-btn": {
    position: "absolute",
    top: "5px",
    right: "5px",
  },
}));

const RejectAppointmentDialog = forwardRef(
  ({ handleSendRejectReason }, ref) => {
    const { palette } = useTheme();
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [error, setError] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog(params) {
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
      },
    }));

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          fontSize={"1.5rem"}
          fontFamily={"inter"}
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
        >
          {t("confirmation")}
        </DialogTitle>
        <DialogContent dividers>
          <Typography
            variant="h5"
            textAlign={"center"}
            fontWeight={500}
            color={"custom.tartOrange"}
          >
            {t("reasonCannotAccept")} ?
          </Typography>
          <Box>
            <Label labelText={t("giveReason")} required />
            <TextInput
              styleProps={{ ...globalStyle.textField }}
              multiline
              rows={3}
              placeholder={t("enterReason")}
              inputError={error}
              helperText={error && t("reasonRequired")}
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                setError(false);
              }}
            />
            {/* <Typography variant="body2" mt={1}>
              <span style={{ color: palette.custom.tartOrange }}>Note</span>
              :Confirmation email is send it to someoneexamole@gmail.com
            </Typography> */}
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "8px 18px" }}>
          <GlobalButton
            variant={"custom_outlined"}
            btnText={"close"}
            styleProps={buttonStyle}
            handleClickBtn={handleClose}
          />
          <GlobalButton
            variant={"contained"}
            btnText={"reject"}
            styleProps={buttonStyle}
            handleClickBtn={() => {
              if (!reason.trim()) {
                setError(true);
              } else {
                handleSendRejectReason(reason);
              }
            }}
          />
        </DialogActions>
      </BootstrapDialog>
    );
  }
);

export default RejectAppointmentDialog;
